import Ai from "./server/com/silkplm/rpc/ai/_RpcIndex.js";
import Domain from "./server/com/silkplm/rpc/domain/_RpcIndex.js";
import Healthcheck from "./server/com/silkplm/rpc/healthcheck/_RpcIndex.js";
import Internals from "./server/com/silkplm/rpc/internals/_RpcIndex.js";
import Organization from "./server/com/silkplm/rpc/organization/_RpcIndex.js";
import Plm from "./server/com/silkplm/rpc/plm/_RpcIndex.js";

import Actions from "./server/com/silkplm/rpc/Actions.js";
import Admin from "./server/com/silkplm/rpc/Admin.js";
import AppTranslations from "./server/com/silkplm/rpc/AppTranslations.js";
import Audit from "./server/com/silkplm/rpc/Audit.js";
import Bot from "./server/com/silkplm/rpc/Bot.js";
import BusinessEntities from "./server/com/silkplm/rpc/BusinessEntities.js";
import Countries from "./server/com/silkplm/rpc/Countries.js";
import Dashboards from "./server/com/silkplm/rpc/Dashboards.js";
import DictExportImport from "./server/com/silkplm/rpc/DictExportImport.js";
import ExcelExports from "./server/com/silkplm/rpc/ExcelExports.js";
import Forms from "./server/com/silkplm/rpc/Forms.js";
import FormsStreams from "./server/com/silkplm/rpc/FormsStreams.js";
import Formula from "./server/com/silkplm/rpc/Formula.js";
import Integrations from "./server/com/silkplm/rpc/Integrations.js";
import Interactions from "./server/com/silkplm/rpc/Interactions.js";
import Invitations from "./server/com/silkplm/rpc/Invitations.js";
import Notifications from "./server/com/silkplm/rpc/Notifications.js";
import OpenApi from "./server/com/silkplm/rpc/OpenApi.js";
import OrganizationSetup from "./server/com/silkplm/rpc/OrganizationSetup.js";
import PaintingTools from "./server/com/silkplm/rpc/PaintingTools.js";
import Pantone from "./server/com/silkplm/rpc/Pantone.js";
import Printouts from "./server/com/silkplm/rpc/Printouts.js";
import PySvc from "./server/com/silkplm/rpc/PySvc.js";
import Regions from "./server/com/silkplm/rpc/Regions.js";
import Reports from "./server/com/silkplm/rpc/Reports.js";
import Roles from "./server/com/silkplm/rpc/Roles.js";
import Session from "./server/com/silkplm/rpc/Session.js";
import SplendiFeed from "./server/com/silkplm/rpc/SplendiFeed.js";
import StickyNotes from "./server/com/silkplm/rpc/StickyNotes.js";
import Subscribable from "./server/com/silkplm/rpc/Subscribable.js";
import Subscriptions from "./server/com/silkplm/rpc/Subscriptions.js";
import UserConfig from "./server/com/silkplm/rpc/UserConfig.js";
import Users from "./server/com/silkplm/rpc/Users.js";
import Validators from "./server/com/silkplm/rpc/Validators.js";
import Versioning from "./server/com/silkplm/rpc/Versioning.js";

class _Rpc{
    constructor() {
            /** @type {Ai} */
            this.ai = new Ai();
            /** @type {Domain} */
            this.domain = new Domain();
            /** @type {Healthcheck} */
            this.healthcheck = new Healthcheck();
            /** @type {Internals} */
            this.internals = new Internals();
            /** @type {Organization} */
            this.organization = new Organization();
            /** @type {Plm} */
            this.plm = new Plm();

            /** @type {module:src/server/com/silkplm/rpc/Actions.Actions} */
            this.Actions = new Actions();
            /** @type {module:src/server/com/silkplm/rpc/Admin.Admin} */
            this.Admin = new Admin();
            /** @type {module:src/server/com/silkplm/rpc/AppTranslations.AppTranslations} */
            this.AppTranslations = new AppTranslations();
            /** @type {module:src/server/com/silkplm/rpc/Audit.Audit} */
            this.Audit = new Audit();
            /** @type {module:src/server/com/silkplm/rpc/Bot.Bot} */
            this.Bot = new Bot();
            /** @type {module:src/server/com/silkplm/rpc/BusinessEntities.BusinessEntities} */
            this.BusinessEntities = new BusinessEntities();
            /** @type {module:src/server/com/silkplm/rpc/Countries.Countries} */
            this.Countries = new Countries();
            /** @type {module:src/server/com/silkplm/rpc/Dashboards.Dashboards} */
            this.Dashboards = new Dashboards();
            /** @type {module:src/server/com/silkplm/rpc/DictExportImport.DictExportImport} */
            this.DictExportImport = new DictExportImport();
            /** @type {module:src/server/com/silkplm/rpc/ExcelExports.ExcelExports} */
            this.ExcelExports = new ExcelExports();
            /** @type {module:src/server/com/silkplm/rpc/Forms.Forms} */
            this.Forms = new Forms();
            /** @type {module:src/server/com/silkplm/rpc/FormsStreams.FormsStreams} */
            this.FormsStreams = new FormsStreams();
            /** @type {module:src/server/com/silkplm/rpc/Formula.Formula} */
            this.Formula = new Formula();
            /** @type {module:src/server/com/silkplm/rpc/Integrations.Integrations} */
            this.Integrations = new Integrations();
            /** @type {module:src/server/com/silkplm/rpc/Interactions.Interactions} */
            this.Interactions = new Interactions();
            /** @type {module:src/server/com/silkplm/rpc/Invitations.Invitations} */
            this.Invitations = new Invitations();
            /** @type {module:src/server/com/silkplm/rpc/Notifications.Notifications} */
            this.Notifications = new Notifications();
            /** @type {module:src/server/com/silkplm/rpc/OpenApi.OpenApi} */
            this.OpenApi = new OpenApi();
            /** @type {module:src/server/com/silkplm/rpc/OrganizationSetup.OrganizationSetup} */
            this.OrganizationSetup = new OrganizationSetup();
            /** @type {module:src/server/com/silkplm/rpc/PaintingTools.PaintingTools} */
            this.PaintingTools = new PaintingTools();
            /** @type {module:src/server/com/silkplm/rpc/Pantone.Pantone} */
            this.Pantone = new Pantone();
            /** @type {module:src/server/com/silkplm/rpc/Printouts.Printouts} */
            this.Printouts = new Printouts();
            /** @type {module:src/server/com/silkplm/rpc/PySvc.PySvc} */
            this.PySvc = new PySvc();
            /** @type {module:src/server/com/silkplm/rpc/Regions.Regions} */
            this.Regions = new Regions();
            /** @type {module:src/server/com/silkplm/rpc/Reports.Reports} */
            this.Reports = new Reports();
            /** @type {module:src/server/com/silkplm/rpc/Roles.Roles} */
            this.Roles = new Roles();
            /** @type {module:src/server/com/silkplm/rpc/Session.Session} */
            this.Session = new Session();
            /** @type {module:src/server/com/silkplm/rpc/SplendiFeed.SplendiFeed} */
            this.SplendiFeed = new SplendiFeed();
            /** @type {module:src/server/com/silkplm/rpc/StickyNotes.StickyNotes} */
            this.StickyNotes = new StickyNotes();
            /** @type {module:src/server/com/silkplm/rpc/Subscribable.Subscribable} */
            this.Subscribable = new Subscribable();
            /** @type {module:src/server/com/silkplm/rpc/Subscriptions.Subscriptions} */
            this.Subscriptions = new Subscriptions();
            /** @type {module:src/server/com/silkplm/rpc/UserConfig.UserConfig} */
            this.UserConfig = new UserConfig();
            /** @type {module:src/server/com/silkplm/rpc/Users.Users} */
            this.Users = new Users();
            /** @type {module:src/server/com/silkplm/rpc/Validators.Validators} */
            this.Validators = new Validators();
            /** @type {module:src/server/com/silkplm/rpc/Versioning.Versioning} */
            this.Versioning = new Versioning();
    }
}

/** @type {_Rpc} */
let Rpc = new _Rpc();
export default Rpc;

